import React from 'react';

export default function UserProfileType() {

    return (
        <>
            <h1> Mon profil </h1>
        </>
    );
}